// flat-tree-example.component.ts
 
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { AssetTreeService } from '../../services/asset-tree.service';
import { DEFAULT_ORG_NAME } from 'src/app/shared/constants/global-constants';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { NavigationHistoryService } from 'src/app/services/navigation-history.service';
import { GlobalUtilityService } from 'src/app/shared/services/global-utility.service';
import { DeviceInfoService } from 'src/app/services/device-info.service';
import { MatDialog } from '@angular/material/dialog';


interface SiteNode {
  name: string;
  children?: SiteNode[];
  orgId?: string;
  orgName?:string;
  siteName?: string;
  deviceId?:string;
}
 
interface OrgNode {
  expandable: boolean;
  name: string;
  level: number;
  orgId: string;
  orgName:string;
  siteName?:string
}
 
@Component({
  selector: 'asset-tree',
  templateUrl: './asset-tree.component.html',
  styleUrls: ['./asset-tree.component.scss']
})
export class AssetTreeComponent {

  @ViewChild('confirmHMIAssetClose') confirmHMIAssetClose: TemplateRef<any>;
  private _transformer = (node: SiteNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      orgId: node.orgId,
      orgName: node.orgName,
      siteName: node.siteName,
      deviceId: node.deviceId
    };
  }
  assetHierarchyList = [];
  isDefaultOrg = false;
  searchString = "";
  treeControl = new FlatTreeControl<OrgNode>(
    node => node.level, node => node.expandable);
 
  treeFlattener = new MatTreeFlattener(
    this._transformer, node => node.level, node => node.expandable, node => node.children);
 
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  previousUrl;
  selectedOrgName: any;
  navigationDisable = true;

  constructor(private assetTreeService: AssetTreeService,
    private router: Router,
    private navigationHistoryService: NavigationHistoryService,
    private util: GlobalUtilityService,
    private deviceInfoService: DeviceInfoService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.getAssetTreeData();
  }
  
  getAssetTreeData(){
    this.assetTreeService.getOrganizationSiteData().subscribe((resp:any) => {
      if(resp?.organizations.length > 0){
        this.getDevicesByOrganization(resp.organizations[0].orgName, resp.organizations[0].orgId,false);
        this.formatAssetTreeData(resp.organizations);
      }
      else{
        this.assetTreeService.setShowAssetTreeNav(false);
      }
    });
  }

  exitFromHMITab(){
    this.navigationDisable = false;  
    this.deviceInfoService.setCloseHmiActiveSession(true);
  }

  getDevicesByOrganization(orgName, orgId, clicked){
    if(this.deviceInfoService.getHmiSessionStarted()){
      let dialogRef = this.dialog.open(this.confirmHMIAssetClose, {
        width: '500px',
        height: 'max-content',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if(!this.navigationDisable){
          this.getDevicesByOrganization(orgName, orgId, clicked)
        }
      });
    }
    else{
      if(clicked){
        this.router.navigate(['dashboard']);
        this.assetTreeService.selectedOrgName = orgName;
        this.assetTreeService.selectedSiteName = '';
      }
      else{
        if(!this.assetTreeService.selectedOrgName){
          this.assetTreeService.selectedOrgName = orgName;
        }
      }
      if(orgName.toLowerCase() === DEFAULT_ORG_NAME.toLowerCase()){
        this.isDefaultOrg = true;
      }
      else{
        this.isDefaultOrg = false;
      }
      this.assetTreeService.orgData = {'orgId': orgId, 'defaultOrg': this.isDefaultOrg}
      this.assetTreeService.getDevicesByOrgId(orgId, this.isDefaultOrg).subscribe((devicesResp:any) => {
        this.assetTreeService.devicesData = devicesResp;
        this.assetTreeService.setDevicesDataChanged(true);
      });
    }
    
  }

  formatAssetTreeData(assetList){
    assetList.forEach((asset) => {
      let assetObj = {};
      assetObj['name'] = asset.orgName;
      assetObj['orgId'] = asset.orgId;
      asset.assets.map((item) => {
        item['orgName'] = asset.orgName;
        return item;
      })
      assetObj['children'] =  this.util.sortArrayOfObjects(asset.assets, 'siteName');
      this.assetHierarchyList.push(assetObj);
    });
    this.dataSource.data = this.assetHierarchyList;
  }

  hasChild = (_: number, node: OrgNode) => node.expandable;

  goToDetailPage(deviceId, orgName, siteName) {
    this.assetTreeService.selectedSiteName = siteName;
    if(this.deviceInfoService.getHmiSessionStarted()){
      let dialogRef = this.dialog.open(this.confirmHMIAssetClose, {
        width: '500px',
        height: 'max-content',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if(!this.navigationDisable){
          this.goToDetailPage(deviceId, orgName,siteName);
        }
      });
    }
    else{
      this.assetTreeService.selectedOrgName = orgName;
      this.previousUrl = this.navigationHistoryService.getPreviousUrl();
      let routeUrl = this.previousUrl ?  this.previousUrl.split('/') : '';
      if(routeUrl[4]){
        this.router.navigate(['/dashboard/device', deviceId, routeUrl[4]]);
      }
      else{
        this.router.navigate(['/dashboard/device', deviceId]);
      }
    }
  }

  doSearchFilter(value) {
    this.searchString = value;
  }


  filterLeafNode(node: SiteNode): boolean {
    if (!this.searchString) {
      return false
    }
    return node.siteName.toLowerCase()
      .indexOf(this.searchString?.toLowerCase()) === -1
 }

  filterParentNode(node: OrgNode): boolean {
    if (    
      !this.searchString ||
      node.name.toLowerCase()
      .indexOf(
        this.searchString?.toLowerCase()
      ) !== -1
    ) {
      return false
    }
    const descendants = this.treeControl.getDescendants(node)
    if (
      descendants.some(
        (descendantNode) =>
          descendantNode.siteName
            .toLowerCase()
            .indexOf(this.searchString?.toLowerCase()) !== -1
      )
    ) {
      return false
    }
    return true
  }

}